export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-base">
                <i className="ri-fire-fill"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                黑料入口
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              百科式黑料事件科普平台，提供黑料事件背景、经过解读，
              黑料网在线观看与黑料在线观看视频，黑料百科知识盘点，
              满足你的求知欲。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2.5">
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">焦点专题</a>
              <a href="#index" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">专题索引</a>
              <a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">深度解读</a>
              <a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">常见问答</a>
              <a href="#about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">关于我们</a>
            </nav>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50 mb-4">热门专题</h3>
            <nav className="flex flex-col gap-2.5">
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">艺人税务风波</a>
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">直播带货翻车</a>
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">数据泄露事件</a>
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">食品安全调查</a>
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">选秀黑幕揭秘</a>
            </nav>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              黑料入口与多家媒体机构、行业研究组织保持内容合作与信息共享关系，
              共同致力于为读者提供真实、全面的事件解读。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 黑料入口 - 黑料百科知识解读科普平台. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#hero" className="hover:text-primary-400 transition-colors duration-200">用户协议</a>
            <a href="#hero" className="hover:text-primary-400 transition-colors duration-200">隐私政策</a>
            <a href="#contact" className="hover:text-primary-400 transition-colors duration-200">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}